import { render, staticRenderFns } from "./TypeDocumentAdd.vue?vue&type=template&id=4ca2c93e&scoped=true"
import script from "./TypeDocumentAdd.vue?vue&type=script&lang=js"
export * from "./TypeDocumentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2c93e",
  null
  
)

export default component.exports